import { Helmet } from "react-helmet"
import { useLocation } from "react-router-dom";
import useInjectHeadHTML from "../../hooks/useInjectHeadHTML";

const HelmetTags = ({ business }) => {
    const { heads, headerTags, favicon, name, domain, TagmanagerCode } = business;
    const location = useLocation()
    const currentHead = heads?.find(head => head.url === location.pathname);

    useInjectHeadHTML(headerTags, "headerTags");
    useInjectHeadHTML(currentHead?.metaTags, "metaTags");

    const pageTitle = currentHead?.title || "لذت فوتبال | بیمه دات‌کام";
    const pageDescription = currentHead?.description;

    return (
        <Helmet>
            <title>{pageTitle}</title>
            <meta name="description" content={pageDescription} />
            {currentHead?.canonical ? <link rel="canonical" href={currentHead.canonical} /> : ""}
            {favicon ? <link rel="shortcut icon" href={favicon} /> : ""}

            <meta name="og:type" content="website" />
            {domain ? <meta name="og:url" content={domain} /> : ""}
            {name ? <meta name="og:site_name" content={name} /> : ""}
            {pageTitle ? <meta property="og:title" content={pageTitle} /> : ""}
            {pageDescription ? <meta property="og:description" content={pageDescription} /> : ""}
            {TagmanagerCode ? <script>
                {`
                    (function (w, d, s, l, i) {
                    w[l] = w[l] || []; w[l].push({
                        'gtm.start':
                        new Date().getTime(), event: 'gtm.js'
                    }); var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
                    })(window, document, 'script', 'dataLayer', '${TagmanagerCode}');
                `}
            </script> : ""}
        </Helmet>
    )
}

export default HelmetTags